import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { changeWebTitle } from '../../helpers/utils';

import { useFacebookPixel } from '../../hooks/facebook';

import { getShowName, getWordingShowName } from '../../constants/titles';
import { TRACK } from '../../constants/facebook/events';

const Location = () => {
  const location = useLocation();
  const facebookPixel = useFacebookPixel();
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof facebookPixel === 'function') facebookPixel('pageView', TRACK);
  }, [facebookPixel]);

  useEffect(() => {
    const wording = getWordingShowName(location.pathname);
    let title = t(wording);
    if (title === wording) {
      title = getShowName(location.pathname);
    }
    changeWebTitle(title);
  }, [location]);

  return '';
};

export default Location;
